module.exports = __webpack_public_path__ + "static/img/未标题-1.293a2c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/套装/未标题-1.png
// module id = BmJi
// module chunks = 0